import proj4 from "proj4";
// UTM-K는 사전에 정의되어 있지 않으므로 직접 정의
proj4.defs("EPSG:5179", "+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +units=m +no_defs");
// Usage: CoordTransformer.convert(sourceEPSG, targetEPSG, [x, y])
class CoordTransformer {
    static convert(source, target, xy) {
        return proj4(source, target, xy);
    }
}
export class Coord {
    x;
    y;
    // EPSG key for this coordinate system (e.g., 'EPSG:4326')
    static key;
    constructor(x, y) {
        this.x = x;
        this.y = y;
    }
    toString() {
        const { lat, lon } = this.toLatLng();
        return `${lat},${lon}`;
    }
    convert(targetKey) {
        const selfKey = this.constructor.key;
        return CoordTransformer.convert(selfKey, targetKey, [this.x, this.y]);
    }
}
// WGS84 coordinate (EPSG:4326) for latitude/longitude, GPS standard
export class Wgs84 extends Coord {
    static key = "EPSG:4326";
    static from(ll) {
        return new Wgs84(ll.lat, ll.lon);
    }
    constructor(lat, lon) {
        super(lon, lat); // x=lon, y=lat
    }
    toLatLng() {
        return { lat: this.y, lon: this.x };
    }
    // Haversine formula. See https://en.wikipedia.org/wiki/Haversine_formula
    distanceTo(other) {
        const toRad = (d) => (d * Math.PI) / 180;
        const φ1 = toRad(this.y);
        const λ1 = toRad(this.x);
        const φ2 = toRad(other.y);
        const λ2 = toRad(other.x);
        const dφ = φ2 - φ1;
        const dλ = λ2 - λ1;
        const R = 6371008.8; // mean Earth radius in meters
        const h = Math.sin(dφ / 2) ** 2 + Math.cos(φ1) * Math.cos(φ2) * Math.sin(dλ / 2) ** 2;
        return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
    }
}
// UTM-K coordinate (EPSG:5179)
export class UtmK extends Coord {
    x;
    y;
    static key = "EPSG:5179";
    constructor(x, y) {
        super(x, y);
        this.x = x;
        this.y = y;
    }
    static fromXY(x, y) {
        return new UtmK(x, y);
    }
    static fromLatLng(ll) {
        const [x, y] = CoordTransformer.convert(Wgs84.key, UtmK.key, [ll.lon, ll.lat]);
        return new UtmK(x, y);
    }
    toLatLng() {
        const [lon, lat] = CoordTransformer.convert(UtmK.key, Wgs84.key, [this.x, this.y]);
        return { lat, lon };
    }
    // 일반 좌표평면 상의 유클리드 거리
    distanceTo(other) {
        const dx = other.x - this.x;
        const dy = other.y - this.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
}
